import { Navigate, Outlet, useLocation, useNavigate } from "react-router";
import secureStorage from "../config/encrypt";


const AuthGuard = ({ children }) => {
    const authUser = secureStorage.getItem("authUserInfo");
    const location = useLocation();
    // Allow access to login page without auth
    if (location.pathname === "/login" ||location.pathname === "/") return <Outlet />;
    // If user is not logged in, redirect to login
    if (!authUser) {
        return <Navigate to="/login" replace />;
    }
     if (children) return children;
    // Otherwise, render the nested routes
    return <Outlet />;
};

export default AuthGuard;
